
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { send_email_emailJs } from '../../../actions/shared_actions'
import { FadeInSection } from '../../application_components/public_landing_page/home_window'
import { SubmitBtn } from '../../sharable_components/small_components/buttons/buttons'
import { TextArea } from '../../sharable_components/small_components/input_boxes/input_boxes'
import './faqs.css'

import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const Faqs = ({qsns}) => {
    const [message, setMessage] = useState('')

    const dispatch = useDispatch()
    const sendEmail = (e) => {
        e.preventDefault()
        dispatch(send_email_emailJs({message:message, message_category:'FAQ'}))
    }

    return (
        <div>
            <div className="landing_images_5 landing_center" id="site_cover_image">
                <Helmet>
                    <title>DGA | FAQs</title>
                </Helmet>
                <div className="company_details">
                    <div className="company_name smaller_company_name" id="company_name">
                        Frequently Asked Questions
                    </div>
                    <div className="tag_line">
                        Your questions answered
                    </div>
                </div>
                <div className="navigation_on_home_container">
                </div> 
            </div>

            <div className="packages_main middle_component paper" style={{marginTop:'0px'}}>
                <div className="centered_div">
                    {qsns.length > 0 && 
                        qsns.map(q=> 
                            <FadeInSection>
                                <div key={q.question}>
                                    <FaqsComponent q={q}/>
                                </div>
                            </FadeInSection>
                            )
                    }
                </div>
                <FadeInSection>
                    <div className='paper'>
                        <h4>I would like to ask a question...</h4>
                        <div>
                            <TextArea placeholder={'What would you like to ask?'} onChange={e=>setMessage(e.target.value)} value={message} />
                            <SubmitBtn onsubmitfn={e=>sendEmail(e)}/>
                        </div>
                    </div>
                </FadeInSection>
			</div>
        </div>
    )
}

const FaqsComponent2 = ({q}) => {

    const [showAns, setShowAns] = useState(false)


    return (
        <div className="faq_container">
            <div className="faq_qsn flex_row_qsn"  onClick={e=>setShowAns(!showAns)}>
                <div id='question'>
                    {q.question}
                </div>
                <div>
                    {showAns? <KeyboardArrowDown />:<KeyboardArrowUp />}
                </div>
            </div>
            <div className={`faq_ans ${!showAns? '':'hidden_ans'}`}>
                {q.answer}
            </div>
        </div>
    )
}


export function FaqsComponent({q}) {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div style={{marginTop:'15px'}}>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: '33%', flexShrink: 0 }}>
            {q.category}
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>{q.question}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {q.answer}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}